import type { AppState } from '@store/types'

import { authSelector } from '@/hooks/useAuth'
import type { AccountData } from './types'

export const selectAccountData = (state: AppState): AccountData => {
  const {
    emailAddress,
    firstName,
    country,
    timeFormat,
    dateFormat,
    companyName,
    lastName,
    notifyComments,
    notifyProjectDigest,
    notifyFrequency,
    notifyDailyHour,
    timezone,
  } = authSelector(state)

  return {
    emailAddress,
    firstName,
    country,
    timeFormat,
    dateFormat,
    companyName,
    lastName,
    notifyComments,
    notifyProjectDigest,
    notifyFrequency,
    notifyDailyHour,
    timezone,
  }
}

export const selectOtp = (state: AppState) => state.account.otp

export const selectEmailChoices = (state: AppState) => state.account.emails
